<div class="d-flex">
  <video class="d-flex m-auto" style="max-height: 75%" autoplay loop muted oncanplay="this.play()" onloadedmetadata="this.muted = true">
    <source src="assets/img/AssurCard_Animation.webm" type="video/webm" />
  </video>
</div>
